import 'bootstrap/dist/css/bootstrap.css';
import LZString from 'lz-string';
import moment from 'moment';
import React, { useState, useEffect } from 'react';
import logo from './../../assets/img/favicon-dark.png';
import CommonUtils from '../../util/CommonUtils';
import SessionManager from '../../routes/SessionManager';
import API from '../../service/SiteKickAPIService';

function HumanPowerReport() {

  const getPathParams = () => {
    var pathParams = window.location.search;
    pathParams = pathParams.length > 0 ? pathParams.substring(1) : '';
    return pathParams.length > 0 ? JSON.parse(LZString.decompressFromBase64(pathParams)) : {};
  }

  const [zones, setZones] = useState([])
  const [user, setUser] = useState(getPathParams());
  const [person_info, setPersonInfo] = useState([]);
  let timezone = user.site_selected.site_iana_timezone;

  let sessionManager = new SessionManager();
  sessionManager.storeCookie('user', user);

  useEffect(() => {
    document.body.style.backgroundColor = '#fff';
    setUser(user);
    fetchHumanPowerReport();
  }, [])

  const fetchHumanPowerReport = () => {

    var data = {
      report_type: 'daily_report',
      customer_id: user.customer_id,
      site_id: user.site_selected.site_id,
      user_login: user.user_login,
      user_token: user.user_token,
      date: user.date,
      timezone: timezone
    }

    let { work_hours_start, work_hours_end } = user.site_selected.site_config.work_hours;
    data = { ...data, work_hours_start, work_hours_end: work_hours_end.replace(":00", ":59") }
    CommonUtils.ajax(
      {
        url: API.REPORTS.STANDARD_DAILY,
        type: 'POST',
        contentType: "application/json; charset=utf-8",
        dataType: "json",
        data: JSON.stringify(data)
      }
    ).then(
      (res) => {
        if (res.status && res.status.code === 200) {
          var person_info = res.data.person_info;
          setZones(user.zones);
          setPersonInfo(person_info);
        }
      },
      (res) => {

      });
  }

  const setPDFContentReady = () => {
    window.status = 'ready';
  }

  return (
    <React.Fragment>

      <div className="container">
        <div className="row">
          <div className="col-md-12 my-5">
            <span className="navbar-brand text-primary">
              <img src={logo} alt="logo" style={{ width: "25px", marginRight: '10px' }} />
              {"SiteSupt OnDemand"}
            </span>
          </div>
        </div>
        <div className="row">
          <div className="col-md-12">
            <h4>Man Power Report</h4>
          </div>
          <div className="col-md-12">
            <h5 className="text-app">{user && user.site_selected.site_name}</h5>
          </div>

          <div className="col-md-12">
            <table className="table mt-5">
              <thead>
                <tr className="bg-primary text-dark">
                  <th className="p-0"><div className="bg-primary p-2 text-white">Zone Name</div></th>
                  <th className="p-0"><div className="bg-primary p-2 text-white">Max. Person Count</div></th>
                  <th className="p-0"><div className="bg-primary p-2 text-white">First Appearance</div></th>
                  <th className="p-0"><div className="bg-primary p-2 text-white">Last Appearance</div></th>
                </tr>
              </thead>
              <tbody>
                {
                  zones.map((w, i) => (
                    ((w.location_config === undefined || w.location_config.feature_controls === undefined || w.location_config.feature_controls.motion_detection === undefined) || (w.location_config && w.location_config.feature_controls && w.location_config.feature_controls.motion_detection && w.location_config.feature_controls.motion_detection.enabled)) &&
                    <tr className="font-size-12" key={i} zone={w}>
                      <td>{w.location_name}</td>
                      <td>{person_info[w.location_id] ? person_info[w.location_id].max_person_count : 0}</td>
                      <td>{person_info[w.location_id] ? moment.tz(person_info[w.location_id].start_person_ts * 1000, timezone).format('YYYY-MM-DD HH:mm') : 0}</td>
                      <td>{person_info[w.location_id] ? moment.tz(person_info[w.location_id].last_person_ts * 1000, timezone).format('YYYY-MM-DD HH:mm') : 0}</td>
                    </tr>
                  ))
                }
              </tbody>
            </table>
            {setPDFContentReady()}
          </div>
        </div>

      </div>
    </React.Fragment>
  )

}
export default HumanPowerReport;